var _path, _g, _path2, _path3, _g2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 36,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_741_2786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 31,
    width: 10,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 31.124H15.4869V35.0269H6.43359V31.124Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_741_2786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4758 33.0623C15.4758 34.1257 13.4587 34.9876 10.9703 34.9876C8.482 34.9876 6.46484 34.1257 6.46484 33.0623C6.46484 31.9997 8.482 31.1367 10.9703 31.1367C13.4587 31.1367 15.4758 31.9997 15.4758 33.0623Z",
    fill: "#F9A72B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.384 32.5965C15.384 33.6599 13.3876 34.5218 10.9246 34.5218C8.46155 34.5218 6.46484 33.6599 6.46484 32.5965C6.46484 31.5332 8.46155 30.6709 10.9246 30.6709C13.3876 30.6709 15.384 31.5332 15.384 32.5965Z",
    fill: "#FCD24F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_741_2786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.844727 0.704102H21V32.634H0.844727V0.704102Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_741_2786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.097 0.744141C11.0378 0.744141 10.9792 0.747954 10.9202 0.749341C10.8609 0.747954 10.8023 0.744141 10.7431 0.744141C5.27266 0.744141 0.837891 5.36995 0.837891 11.0758C0.837891 12.0493 1.21511 14.3005 1.78198 15.2349L10.9202 32.5968L20.0578 15.2349C20.6246 14.3005 21.0022 12.0493 21.0022 11.0758C21.0022 5.36995 16.5681 0.744141 11.097 0.744141Z",
    fill: "#E33924"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3904 9.92399C16.3904 12.947 13.9408 15.3972 10.92 15.3972C7.89873 15.3972 5.44922 12.947 5.44922 9.92399C5.44922 6.90137 7.89873 4.45117 10.92 4.45117C13.9408 4.45117 16.3904 6.90137 16.3904 9.92399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location_pin_icon.07a1b779a4cd7d43b6055fd863175059.svg";
export { ForwardRef as ReactComponent };